import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChecklistV2ListNavigationTabsComponent } from './checklist-v2-list-navigation-tabs/checklist-v2-list-navigation-tabs.component';
import { FiTabsModule } from '@fi-app/utilities/tabs/tabs.module';
import { MatButtonModule } from '@angular/material/button';
import { UIRouterModule } from '@uirouter/angular';
import { ChecklistV2ScheduleStates } from '@fi-app/checklist/checklist-v2/checklist-v2-schedule-states';
import { ChecklistV2States } from '@fi-app/checklist/checklist-v2/checklist-v2.states';
import { FiChecklist2ViewerModule } from '@fi-shared/checklist/fi-checklist2-viewer/fi-checklist2-viewer.module';
import { ChecklistV2ReportStates } from '@fi-app/checklist/checklist-v2/checklist-v2-report-states';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { ChecklistV2TemplateStates } from '@fi-app/checklist/checklist-v2/checklist-v2-template-states';
import { ChecklistV2AuditStates } from '@fi-app/checklist/checklist-v2/checklist-v2-audit.states';
import { ChecklistV2ListAuditNavigationTabsComponent } from './checklist-v2-list-audit-navigation-tabs/checklist-v2-list-audit-navigation-tabs.component';
import { ChecklistV2AuditScheduleStates } from '@fi-app/checklist/checklist-v2/checklist-v2-audit-schedule-states';
import { ChecklistV2AuditTemplateStates } from '@fi-app/checklist/checklist-v2/checklist-v2-audit-template-states';
import { ChecklistV2AuditReportStates } from '@fi-app/checklist/checklist-v2/checklist-v2-audit-report-states';

@NgModule({
    imports: [
        CommonModule,
        FiTabsModule,
        MatButtonModule,
        UIRouterModule.forChild(ChecklistV2States),
        UIRouterModule.forChild(ChecklistV2TemplateStates),
        UIRouterModule.forChild(ChecklistV2ScheduleStates),
        UIRouterModule.forChild(ChecklistV2ReportStates),
        UIRouterModule.forChild(ChecklistV2AuditStates),
        UIRouterModule.forChild(ChecklistV2AuditScheduleStates),
        UIRouterModule.forChild(ChecklistV2AuditTemplateStates),
        UIRouterModule.forChild(ChecklistV2AuditReportStates),
        FiChecklist2ViewerModule,
        FiAppTextSharedModule,
        MatIconModule,
    ],
    declarations: [ChecklistV2ListNavigationTabsComponent, ChecklistV2ListAuditNavigationTabsComponent],
})
export class ChecklistV2Module {}
